import { render, staticRenderFns } from "./VxCellPermissionsIconStatus.vue?vue&type=template&id=ce518162&"
import script from "./VxCellPermissionsIconStatus.vue?vue&type=script&lang=js&"
export * from "./VxCellPermissionsIconStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports